var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"content"},[_c('h1',{staticStyle:{"color":"#eee","font-size":"50px"}},[_vm._v("朔州市旌普拉斯网络科技信息有限公司")])]),_c('div',{staticClass:"icp"},[_vm._v(" ©2025 朔州市旌普拉斯网络科技信息有限公司 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener"}},[_vm._v("晋ICP备2024051469号")])])])
}]

export { render, staticRenderFns }